import { Outlet } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { Topbar } from './Topbar'
import { Sidebar } from './Sidebar'
import type { AuthState } from '@/hooks/useAuth'

interface LayoutProps {
  auth: AuthState
  can: (permission: string) => boolean
}

export function Layout({ auth, can }: LayoutProps) {
  return (
    <div className="h-screen flex flex-col overflow-hidden bg-background">
      <Topbar auth={auth} can={can} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar can={can} auth={auth} />
        <main className="flex-1 overflow-y-auto p-6 bg-background flex flex-col">
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  )
}
